export default __webpack_public_path__ + "static/media/purpleTheme-boy.d30fe951.svg";